import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import ContentResourceCard from "@qlik/qlik/src/components/CardDeckContainer/Resource_Cards/ContentResourceCard";

/**
 * DeckResourceCards component
 * @param {Object} props - The props for the component
 * @param {Object} props.data - The data for the component
 * @param {Array} props.data.cardItems - The card items for the component
 * @param {string} props.data.title - The title for the component
 * @returns {JSX.Element} - Rendered component
 */
const DeckResourceCards = ({ data }) => {
    const { title, cardItems = [], customId, additionalConfiguration } = data ?? {};
    const sectionPaddingClassName = getSpacingClassName(
        additionalConfiguration,
        "pt-11.25 lg:pt-2.25 pb-15 lg:pb-[99px]"
    );

    return (
        <section className={`${sectionPaddingClassName} overflow-hidden`} id={customId}>
            <div className="container">
                {title && (
                    <h2 className="md:text-center text-4xl lg:text-6xl tracking-tight8 lg:tracking-tight10">{title}</h2>
                )}
                <div className="grid gap-5 mt-10 lg:mt-15 md:grid-cols-3 lg:gap-7.5">
                    {/* Card Items */}
                    {cardItems.map((card) => (
                        <ContentResourceCard key={card.id} card={card} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DeckResourceCards;
